import { render, staticRenderFns } from "./DraftInvoiceGold.vue?vue&type=template&id=91aacad6&"
import script from "./DraftInvoiceGold.vue?vue&type=script&lang=js&"
export * from "./DraftInvoiceGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports